import { withFormik } from "formik"
import * as Yup from "yup"
import NewAmortizacion from "./form"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    importe: Yup.number()
      .required(t("errors.importRequired"))
      .typeError(t("errors.numericValue")),
    comisionImporte: Yup.object()
      .shape({
        tipoImporte: Yup.number().nullable(),
        valor: Yup.number(),
      })
      .required(t("errors.typeRequired"))
      .typeError(""),
    cuentaContableEmpresaId: Yup.string()
      .nullable()
      .when("comisionImporte", {
        is: ({ valor }: $TSMigrationFixMe) => valor > 0,
        then: Yup.string().required(t("errors.enterOption")).nullable(),
        otherwise: Yup.string().nullable(),
      })
      .nullable()
      .typeError(""),
  })

const NewAmortizacionForm = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  mapPropsToValues: () => {
    return {
      importe: 0,
      cuentaContableEmpresaId: null,
      comisionImporte: {
        tipoImporte: 1,
        valor: 0,
      },
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'createAmortizacion' does not exist on ty...
    props.createAmortizacion(values)
  },
})(NewAmortizacion)

export default NewAmortizacionForm
